document.addEventListener( 'DOMContentLoaded', function () {

		Fancybox.bind('[data-fancybox]', {
			// Your custom options
		});

		document.querySelectorAll('input[name="default-email"]').forEach((input) => {
			input.addEventListener('input', function() {
				// Удаляем все кириллические символы
				this.value = this.value.replace(/[а-яА-ЯёЁ]/g, '');
			});
		});

		// Маска на телефон
		document.querySelectorAll( 'input[name*=-phone]' ).forEach( initPhoneMask );

		// анимация лейблов форм
		if ( isExist( '.form-wrapper' ) ) {
			const forms = document.querySelectorAll( '.form-wrapper' );

			forms.forEach( ( form ) => {
				const inputs = form.querySelectorAll( 'input, textarea' );
				inputs.forEach( ( input ) => {
					input.onfocus = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.add( 'active' )
					}
					input.onblur = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.remove( 'active' )
					}
				} );
			} );
		}

		// валидация форм
		let forms = document.querySelectorAll('.wpcf7');

		for (let form of forms) {
			form.addEventListener('wpcf7mailsent', function () {
				Fancybox.close();
				Fancybox.show([{src: '#success-popup', type: "inline"}]);
			});

			form.addEventListener('wpcf7mailfailed', function () {
				Fancybox.close();
				Fancybox.show([{src: '#failed-popup', type: "inline"}]);
			});
		}

		sal({
			threshold: .1,
		});

		if ( isExist( '.search__input' ) ) {
			const searchInputs = document.querySelectorAll( '.search__input' );

			const updateSearchFilledState = ( input ) => {
				input.classList.toggle( 'search__input--filled', input.value.trim() !== '' );
			};

			searchInputs.forEach( ( input ) => {
				updateSearchFilledState( input );
				input.addEventListener( 'input', () => updateSearchFilledState( input ) );
			} );
		}

	if ( isExist( '.burger-btn' ) ) {
		const burgerBtn = document.querySelector( '.burger-btn' );
		const burger = burgerBtn.closest( '.burger' );
		const burgerMenu = burger?.querySelector( '.burger-menu' );
		const burgerOverlay = burger?.querySelector( '.burger-overlay' );
		const body = document.body;
		const html = document.documentElement;

		const syncFixedElementsOffset = ( isOpen ) => {
			if ( isOpen ) {
				const scrollbarWidth = window.innerWidth - html.clientWidth;
				html.style.setProperty( '--fancybox-scrollbar-compensate', `${Math.max( 0, scrollbarWidth )}px` );
				html.classList.add( 'with-fancybox' );
				return;
			}

			html.classList.remove( 'with-fancybox' );
			html.style.removeProperty( '--fancybox-scrollbar-compensate' );
		};

		const setBurgerState = ( isOpen ) => {
			burgerBtn.classList.toggle( 'is-active', isOpen );
			burger?.classList.toggle( 'is-open', isOpen );
			burgerMenu?.classList.toggle( 'is-open', isOpen );
			burgerOverlay?.classList.toggle( 'is-open', isOpen );

			burgerBtn.setAttribute( 'aria-expanded', String( isOpen ) );
			burgerBtn.setAttribute( 'aria-label', isOpen ? 'Закрыть меню' : 'Открыть меню' );

			if ( burgerMenu ) {
				burgerMenu.setAttribute( 'aria-hidden', String( !isOpen ) );
			}

			if ( burgerOverlay ) {
				burgerOverlay.setAttribute( 'aria-hidden', String( !isOpen ) );
			}

			syncFixedElementsOffset( isOpen );
			body.classList.toggle( 'no-scroll', isOpen );
			body.style.overflow = isOpen ? 'hidden' : '';
		};

		burgerBtn.addEventListener( 'click', () => {
			const isOpen = !burgerBtn.classList.contains( 'is-active' );
			setBurgerState( isOpen );
		} );

		burgerOverlay?.addEventListener( 'click', () => {
			setBurgerState( false );
		} );

		// Закрытие бургера при клике на пункты меню
		if ( burgerMenu ) {
			const menuItems = burgerMenu.querySelectorAll( '.sub-menu a' );
			menuItems.forEach( ( item ) => {
				item.addEventListener( 'click', () => {
					item.closest('.menu-item-type-post_type').classList.remove('is-open');

					setBurgerState( false );
				} );
			} );
		}

		setBurgerState( false );
	}

		const menuChevronSvg = `
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
				<path d="M10 14C9.88377 14 9.76741 13.9593 9.67866 13.8779L5.13321 9.71127C4.9556 9.54846 4.9556 9.28482 5.13321 9.12211C5.31082 8.9594 5.59844 8.9593 5.77594 9.12211L10 12.9942L14.2241 9.12211C14.4017 8.9593 14.6893 8.9593 14.8668 9.12211C15.0443 9.28492 15.0444 9.54856 14.8668 9.71127L10.3214 13.8779C10.2326 13.9593 10.1163 14 10 14Z" fill="currentColor" />
			</svg>
		`;
		const menusWithDropdown = document.querySelectorAll( '.navigation .menu, .burger-menu .menu' );

		menusWithDropdown.forEach( ( menu ) => {
			const menuItemsWithChildren = menu.querySelectorAll( '.menu-item-has-children' );

			menuItemsWithChildren.forEach( ( item ) => {
				const subMenu = item.querySelector( ':scope > .sub-menu' );
				const link = item.querySelector( ':scope > a' );
				const isBurgerMenu = Boolean( menu.closest( '.burger-menu' ) );

				if ( !subMenu || !link || link.querySelector( '.menu-link-chevron' ) ) {
					return;
				}

				const chevron = document.createElement( 'span' );
				chevron.className = 'menu-link-chevron';
				chevron.setAttribute( 'aria-hidden', 'true' );
				chevron.innerHTML = menuChevronSvg;
				link.appendChild( chevron );

				if ( isBurgerMenu ) {
					link.addEventListener( 'click', ( event ) => {
						const isOpen = item.classList.contains( 'is-open' );

						if ( !isOpen ) {
							event.preventDefault();
							item.classList.add( 'is-open' );
							link.setAttribute( 'aria-expanded', 'true' );
						}
					} );

					const closeSubmenu = ( event ) => {
						event.preventDefault();
						event.stopPropagation();
						item.classList.remove( 'is-open' );
						link.setAttribute( 'aria-expanded', 'false' );
					};

					link.querySelector( '.menu-link-chevron' )?.addEventListener( 'click', closeSubmenu );
				}
			} );
		} );
} );
